import { tns } from "tiny-slider/src/tiny-slider";

class VideoSlider {
  constructor(container) {
    this.container = container;
    if (container) {
      this.init();
    }
  }

  init() {
    var slider = tns({
      container: this.container,
      mode: 'carousel',
      axis: 'horizontal',

      items: 1,
      gutter: 20,
      edgePadding: 20,
      loop: false,
      controls: false,
      responsive: {
        576: {
          items: 1
        },
        768: {
          items: 2,
          slideBy: 'page',
          controls: true
        },
        992: {
          items: 3,
          slideBy: 'page',
          controls: true
        }
      }
    });
  }
}
export default VideoSlider;


